var vuedlhelper = {
    getCartLines: function(cartLines){
        const gaCartItems = [];
        for(var i=0;i<cartLines.length;i++) {
            var ga_cart_item = {};
            ga_cart_item.index = i;
            ga_cart_item.item_name = cartLines[i].Description;
            ga_cart_item.item_id = cartLines[i].ProductCode;
            ga_cart_item.price = cartLines[i].GrossPrice.toFixed(2);
            ga_cart_item.item_brand = cartLines[i].BrandTitle;
            ga_cart_item.quantity = cartLines[i].Quantity;
            gaCartItems.push ( ga_cart_item );	
        }
        return gaCartItems;
    },
    begin_checkout: function (cart) {     
        if (window.dataLayer){
            window.dataLayer.push({ ecommerce: null });
            window.dataLayer.push({
                'event': 'begin_checkout',
                'ecommerce': {
                    currency: "EUR",
                    value: cart.GrandTotal.toFixed(2),
                    coupon: cart.PromotionCode ? cart.PromotionCode : "",
                    items: vuedlhelper.getCartLines(cart.Lines)
                }
            });
        }
    },
    add_shipping_info: function(cart, option){
        if (window.dataLayer){
            window.dataLayer.push({ ecommerce: null });
            window.dataLayer.push({
                'event': 'add_shipping_info',
                'ecommerce': {
                    currency: "EUR",
                    value: cart.GrandTotal.toFixed(2),
                    coupon: cart.PromotionCode ? cart.PromotionCode : "",
                    shipping_tier: option,
                    items: vuedlhelper.getCartLines(cart.Lines)
                }
            });
        }
    },
    add_payment_info: function(cart, option){
        if (window.dataLayer){
            window.dataLayer.push({ ecommerce: null });
            window.dataLayer.push({
                'event': 'add_payment_info',
                'ecommerce': {
                    currency: "EUR",
                    value: cart.GrandTotal.toFixed(2),
                    coupon: cart.PromotionCode ? cart.PromotionCode : "",
                    payment_type: option,
                    items: vuedlhelper.getCartLines(cart.Lines)
                }
            });
        }
    },
    checkout: function(step) {
        if (window.dataLayer){
            window.dataLayer.push({
                'event': 'eec.checkout',
                'ecommerce': {
                    'checkout': {
                        'actionField': {
                            'step': step
                        }
                    }
                }
            });
        }
    },
    checkout_option: function(step, option) {
        if (window.dataLayer){
            window.dataLayer.push({
                'event': 'eec.checkout_option',
                'ecommerce': {
                    'checkout': {
                        'actionField': {
                            'step': step,
                            'option': option
                        }
                    }
                }
            });
        }
    }
};

var store = {
    SubscribeNewsletter: true,
    hideOptinCheckbox: "",
    Roles: "",
    init() {
        var self = this;
        self.getIdentity();
    },
    getIdentity: function() {
        var self = this;
        jQuery.ajax({
            url: "/api/identity?r=" + Math.random(), 
            type: "get", 
            dataType: "json", 
            context: this,
            success: function (data, status, xhr) {
                if (status == "success") {
                    
                    self.Roles = data.Roles;

                    if ( data.MailingLists[0] !== undefined && data.MailingLists[0].Subscribed !== undefined ) {
                        
                        self.SubscribeNewsletter = data.MailingLists[0].Subscribed;

                        if ( data.MailingLists[0].Subscribed === true ) {
                            self.hideOptinCheckbox = true;
                        }else{
                            self.hideOptinCheckbox = false;
                        }
                    }
                }   
            }
        });
    },
    updateOptin(value) {
        self.SubscribeNewsletter = value;
    },
    scrollToTop() {
        window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
    },
}

Date.prototype.toJSONLocal = function() {
    function addZ(n) {
    return (n<10? '0' : '') + n;
    }
    return this.getFullYear() + '-' + 
            addZ(this.getMonth() + 1) + '-' + 
            addZ(this.getDate());
} 
        
const config = {
    useConstraintAttrs: false,
    events: 'blur',
    mode: 'lazy'
};

Vue.use(VeeValidate, config);
Vue.use(VueObserveVisibility)

// Register the component globally.
Vue.component('ValidationProvider', VeeValidate.ValidationProvider);
Vue.component('ValidationObserver', VeeValidate.ValidationObserver);

// Add validation rules.
VeeValidate.extend('required', {
    validate (value) {
        return {
            required: true,
            valid: ['', null, undefined].indexOf(value) === -1
        };
    },
    computesRequired: true,
    message: 'verplicht'
});

VeeValidate.extend('integer', {
    validate (value) {
        return !isNaN(value) && 
                parseInt(Number(value)) == value && 
                !isNaN(parseInt(value, 10)); 
    },
    message: 'Vul een nummer in'
});

VeeValidate.extend('date', {
    validate (value) {
        if (value.match(/^(?:(?:31(\/|-|\.)(?:0?[13578]|1[02]))\1|(?:(?:29|30)(\/|-|\.)(?:0?[13-9]|1[0-2])\2))(?:(?:1[6-9]|[2-9]\d)?\d{2})$|^(?:29(\/|-|\.)0?2\3(?:(?:(?:1[6-9]|[2-9]\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1\d|2[0-8])(\/|-|\.)(?:(?:0?[1-9])|(?:1[0-2]))\4(?:(?:1[6-9]|[2-9]\d)?\d{2})$/) == value) {
            return true;
        }else {
            return false;
        }
    },
    message: 'vul een geldige datum in'
});

VeeValidate.extend('email', {
    validate (value) {
        //return value.indexOf('@') > -1;
        if (value.match(/^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+$/i) == value) {
            return true;
        } else {
            return false;
        }
    },
    message: 'Vul een geldig e-mailadres in'
});

VeeValidate.extend('postalcode-nl', {
    validate(value) {
        if ( value.match(/^[0-9]{4}[A-Za-z]{2}$/i) == value && value.length == 6 || value.match(/^[0-9]{4} [A-Za-z]{2}$/i) == value && value.length == 7) {
            return true;
        } else {
            return false;
        }
    },
    message: 'Geen geldige postcode'
});

VeeValidate.extend('postalcode-be', {
    validate(value) {
            if (value.match(/^[0-9]{4}$/i) == value && value.length == 4) {
            return true;
        } else {
            return false;
        }
    },
    message: 'Geen geldige postcode voor België'
});

VeeValidate.extend('postalcode-de', {
    validate(value) {
        if (value.match(/^[0-9]{5}$/i) == value && value.length == 5) {
            return true;
        } else {
            return false;
        }
    },
    message: 'Geen geldige postcode voor Duitsland'
});

VeeValidate.extend('alpha_dash_spaces', {
    validate(value) {
        if (value.match(/[a-z\- ]+/i)) {
            return true;
        } else {
            return false;
        }
    },
    message: 'Er zijn geen cijfers toegestaan'
});

// Add custom validation rules specific fields.
VeeValidate.extend('firstname', {
    validate (value) {
        return {
            required: true,
            valid: ['', null, undefined].indexOf(value) === -1
        };
    },
    computesRequired: true,
    message: 'Voornaam is niet ingevuld'
});


VeeValidate.extend('lastname', {
    validate (value) {
        return {
            required: true,
            valid: ['', null, undefined].indexOf(value) === -1
        };
    },
    computesRequired: true,
    message: 'Achternaam is niet ingevuld'
});

VeeValidate.extend('emailreq', {
    validate (value) {
        return {
            required: true,
            valid: ['', null, undefined].indexOf(value) === -1
        };
    },
    computesRequired: true,
    message: 'E-mailadres is niet ingevuld'
});

VeeValidate.extend('password', {
    validate (value) {
        return {
            required: true,
            valid: ['', null, undefined].indexOf(value) === -1
        };
    },
    computesRequired: true,
    message: 'Vul uw wachtwoord in'
});

VeeValidate.extend('carrier', {
    validate (value) {
        return {
            required: true,
            valid: ['', null, undefined].indexOf(value) === -1
        };
    },
    computesRequired: true,
    message: 'Vervoerder is niet ingevuld'
});

VeeValidate.extend('country', {
    validate (value) {
        return {
            required: true,
            valid: ['', null, undefined].indexOf(value) === -1
        };
    },
    computesRequired: true,
    message: 'Land is niet ingevuld'
});

VeeValidate.extend('city', {
    validate (value) {
        return {
            required: true,
            valid: ['', null, undefined].indexOf(value) === -1
        };
    },
    computesRequired: true,
    message: 'Plaats is niet ingevuld'
});

VeeValidate.extend('street', {
    validate (value) {
        return {
            required: true,
            valid: ['', null, undefined].indexOf(value) === -1
        };
    },
    computesRequired: true,
    message: 'Straat is niet ingevuld'
});

VeeValidate.extend('postalcode', {
    validate (value) {
        return {
            required: true,
            valid: ['', null, undefined].indexOf(value) === -1
        };
    },
    computesRequired: true,
    message: 'Postcode is niet ingevuld'
});

VeeValidate.extend('housenumber', {
    validate (value) {
        return {
            required: true,
            valid: ['', null, undefined].indexOf(value) === -1
        };
    },
    computesRequired: true,
    message: 'Huisnr. is niet ingevuld'
});

VeeValidate.extend('dateofbirth', {
    validate(value) {
        return {
            required: false,
            valid: ['' , null, undefined, 0].indexOf(value) === -1,
        };
    },

    message: 'Geboortedatum is niet ingevuld'
});

VeeValidate.extend('phonenumber', {
    validate (value) {
        if (value.match(/^(?:0|(?:\+|00) ?31 ?)(?:(?:[1-9] ?(?:[0-9] ?){8})|(?:6 ?-? ?[1-9] ?(?:[0-9] ?){7})|(?:[1,2,3,4,5,7,8,9]\d ?-? ?[1-9] ?(?:[0-9] ?){6})|(?:[1,2,3,4,5,7,8,9]\d{2} ?-? ?[1-9] ?(?:[0-9] ?){5}))$/i) == value) {
            return true;
        } else {
            return false;
        }
    },
    message: 'Vul een geldig telefoonnummer in'
});

VeeValidate.extend('phonenumber-de', {
    validate(value) {
        if (value.match(/\(?(\+|00)\(?49\)?[ ()]?([- ()]?\d[- ()]?){10}/g) == value) {
            return true;
        } else {
            return false;
        }
    },
    message: 'Vul een geldig Duits telefoonnummer in'
});

Vue.filter('toCurrency', function (value) {
    if (typeof value !== "number") {
        return value;
    }
    var formatter = new Intl.NumberFormat('nl-NL', {
        style: 'currency',
        currency: 'EUR'
    });
    return formatter.format(value);
});

Vue.filter('toString', function (value) {
    if (!value) return '';
    value = value.toString();
    return value;
});

Vue.filter('toCurrencyOrFree', function (value) {
    if (typeof value !== "number") {
        return value;
    }
    if(value == 0){
        return "<strong class='font-weight-bold text-success'>Gratis</strong>" ;
    }
    var formatter = new Intl.NumberFormat('nl-NL', {
        style: 'currency',
        currency: 'EUR'
    });
    return formatter.format(value);
});

Vue.filter('toCountryName', function (a) {
    if (a === "NL") 
        {return "Nederland";}
    if (a === "BE") 
        {return "Belgie";}
    if (a === "DE") 
        {return "Duitsland";}
    else 
        {return "NL";}
});

Vue.filter('discountType', function (discount) {
    if (discount.Name === "loyalty-x") {
        return "Spaarpunten: " + discount.LoyaltyPoints;
    } else {
        return discount.Description;
    }
});

Vue.component('billing-component', {
    template: '#billing-template',
    props: {
        cart: {
            type: Object,
            function () {
                return { BillingAddress: {} }
            }
        }
    },
    data: function() {
        return {
            siteCulture: _config.siteCulture,
            selectedCountry: _config.selectedCountry,
            countries: _config.countries,
            selectedDoB: 0,
            selectedMoB: 0,
            selectedYoB: 0,
            formTextDoB: "Bijvoorbeeld: 12 juni 1988",
            editAddress: true,
            manualAddress: false,
            authenticated: this.$root.$data.authenticated,
            newAccountEmail: '',
            formTextEmail: "Voorbeeld: naam@domein.nl",
            addressAutoFilled: false,
            addressAutofillError: false,
            addressAutofillErrorText: _addressAutofillAlertText,
            createNewAccount: false,
            usernameExists: false,
            saveClicked:false,
            optIn: store.SubscribeNewsletter,
            optinCheckboxLabelText: _optinCheckboxLabelText,
            hideOptinCheckbox: store.hideOptinCheckbox,
            postalCodeCheck: false,
            NotOrderableForSelectedCountryBilling: this.cart.NotOrderableForSelectedCountryBilling,
            NotOrderableForSelectedCountryShipping: this.cart.NotOrderableForSelectedCountryShipping,
            validDoB: true,
            billingAddressTitle: _billingAddressTitle,
            createAccountText: _createAccountText,
            createAccountAlertText: _createAccountAlertText,
            inputHouseNumberLabel: _inputHouseNumberLabel,
            companyLink: _companyLink,
            showCompanyLink: false,
            btnTextProceed: _btnTextProceed,
            isPending: false,
            inputElementAddressAutocomplete: null,
            autocomplete: null,
            createAutocompleteInfoAlert: true, 
            autocompleteInfoAlertText: _autocompleteInfoAlertText,
            showAutocompleteError: false,
            autocompleteErrorText: "Er is nog geen geldig adres geselecteerd",
            showAutocompleteAddressFieldset: true,
            showManualAddressFieldset: false,
            showBottomBar: false,

            // temporary error messages
            showIdentityCreateError: false,
            showShippingMethodError: false,
            showBillingAddressError: false
        }
    },
    methods: {
        visibilityChanged: function(isVisible) {
            this.showBottomBar = !isVisible
        },
        countryChanged:function() {
            var self = this;

            var country = $.grep(this.countries, function (c) {
                return c.Code == self.cart.BillingAddress.CountryCode;
            })[0];    

            this.cart.BillingAddress.Country = country.Name;

            if (this.cart.BillingAddress.CountryCode === "BE" || this.cart.BillingAddress.CountryCode === "DE" ) {
                self.manualAddress = false;
            }
          
            if(self.inputElementAddressAutocomplete != null) {
                self.inputElementAddressAutocomplete.value = "";
            }

            // EMPTY ADDRESS INPUTS 
            self.cart.BillingAddress.PostalCode =  "";
            self.cart.BillingAddress.City =  "";
            self.cart.BillingAddress.StreetName =  "";
            self.cart.BillingAddress.StreetNumber =  "";
            self.cart.BillingAddress.StreetNumberSuffix =  "";
            
            jQuery.ajax({
                url:"/api/checkout/billing/address/countrycode", 
                type:"post", 
                dataType:"json", 
                context:this,
                data: {
                    "CountryCode": this.cart.BillingAddress.CountryCode
                },
                success: function(data, status, xhr) {
                    if (status == "success") {
                        self.initAddressAutocomplete();
                    }
                }
            });
 
        },
        dateOfBirthChanged:function(event) {
            var dob = event.target.value;
            event.target.setAttribute("value" , dob);
        },
        checkAndContinue:function(invalid,errors) {
            var self = this;
            self.isPending = true;
            
            this.$refs.billingObserver.validate().then(success => {
                self.saveClicked = true;
                
                if(!success){
                    self.isPending = false;
                    return;
                }
                
                //self.createAccount();
                if(self.createNewAccount || !self.authenticated) {
                    self.createAccount();
                } else {
                    self.saveAddress();
                }
            });
        },
        createAccount: function() {
            var self = this;
            self.isPending = true;
            self.errorExistingAccount = false;

            var form = $("#checkout-billing-address-form");
            var re = $(document).find(form).find(".js-grecaptcha");

            if ($(re) != undefined) {
				const siteKey = '6LcOkMAUAAAAAFPmBwe3TzJzkg3k6zXar5CwudUI';
				var e = $(re);
				var formAction = e.data('action');
				var formUrl = '/api/identity/create/';
				
				var formId = e.attr('id');
				
				grecaptcha.execute(siteKey, {action: formAction}).then(function(token) {
                    // SET RECAPCTHA TOKEN
                    $('#'+formId).val(token);
                    
                    jQuery.ajax({
                        url: formUrl, 
                        type:"post", 
                        dataType:"json", 
                        context:this, 
                        data:{
                            culture: culture,
                            emailaddress: self.newAccountEmail, 
                            useexisting: true, 
                            generatepassword: self.createNewAccount,
                            culture: "nl-NL",
                            origin: "checkout",
                            RecaptchaResponse:token,
                        },
                        success: function(data, status, xhr) {
                            if (status == "success" && data.Success && !!data.BillingAddress) {
                                self.createNewAccount = false;
                                self.authenticated = true;
                                self.usernameExists = false;
                                self.saveAddress();
                            } else {
                                self.errorExistingAccount = true;
                                self.isPending = false;
                                
                            }
                        },
                        error: function(){
                            // show error message for /identity/create
                            self.showIdentityCreateError = true
                        },
                        complete: function(xhr, status) {
                            self.isPending = false;
                        }
                    });
                });
            }
        },
        checkUsername: function() {
            var self = this;
            self.isPending = false;
            if(this.newAccountEmail.length > 0) {
                jQuery.ajax({
                    url:"/api/identity/checkusername", 
                    type:"post", 
                    dataType:"json", 
                    context:this,
                    data: {
                        Username:this.newAccountEmail
                    },
                    success: function(data, status, xhr) {
                        if (status == "success") {
                            self.usernameExists = !data.Success;   
                        }
                    },
                    complete: function(xhr, status) {
                        self.isPending = false;
                    }
                });
            }
        },
        showLogin: function(e) {
            e.preventDefault();
            this.$emit('show-login', this.newAccountEmail);
        },
        saveAddress: function() {
            var self = this;
            self.isPending = true;
            self.cart.BillingAddress.IsManual = self.manualAddress;

            if(self.selectedDateOfBirth && self.selectedDateOfBirth != null) {
                self.cart.BillingAddress.DateOfBirth = moment(self.selectedDateOfBirth).toDate().toJSONLocal();
            } else {
                self.cart.BillingAddress.DateOfBirth = null;
            }

            jQuery.ajax({
                url:"/api/checkout/shipping/method/", 
                type:"post", 
                dataType:"json", 
                context:this, 
                data:{ 
                    ShippingMethod:"Delivery"
                },
                success: function(data, status, xhr) { 
                    
                    if (status == "success") {
                        
                        jQuery.ajax({
                            url:"/api/checkout/billing/address/", 
                            type:"post", 
                            dataType:"json", 
                            context:this,
                            data:self.cart.BillingAddress,
                            success: function(data, status, xhr) {
                                if (status == "success") {
                                    self.$emit('next', self.optIn);            
                                }
                            },
                            error: function(){
                                // show error message for /billing/address
                                self.showBillingAddressError = true
                            },
                        });   							
                    }
                },
                error: function(){
                    // show error message for /shipping/method
                    self.showShippingMethodError = true
                },
                complete: function(xhr, status) {
                    self.isPending = false;
                    store.scrollToTop();
                }
            });
            
        },
        checkAddress: function () {
            var self = this;

            // IF POSTCODE + HOUSENNUMBER COMBO CHECK IS ENABLED
            if (!self.postalCodeCheck) {
                return
            }

            // ONLY AVAIBLABLE FOR NL ADDRESSES
            if(self.cart.BillingAddress.CountryCode !== 'NL') {
                //this.addressAutoFilled = false;
                return;
            }

            self.cart.BillingAddress.StreetName = "";
            self.cart.BillingAddress.City = "";
            
            var postalCode = self.cart.BillingAddress.PostalCode;
            var number = self.cart.BillingAddress.StreetNumber;
            var suffix = self.cart.BillingAddress.StreetNumberSuffix;
            var postalCodeValid = postalCode !== undefined && postalCode.match(/^[1-9][0-9]{3}\s?[A-Za-z]{2}$/i) == postalCode && (postalCode.length == 6 || postalCode.length==7);
            var numberValid = number !== undefined && number.length > 0;
            
            if(!postalCodeValid || !numberValid) {
                return;
            }

            setTimeout(function() {
                jQuery.ajax({
                    url: "/api/checkout/billing/street/?PostalCode=" + postalCode + "&StreetNumber=" + number + "&StreetNumberSuffix=" + suffix, 
                    type:"get", 
                    dataType:"json",
                    success: function(data, status, xhr) {
                        if (status == "success") {
                            if(data.Success) {
                                console.log(data.StreetName);
                                // AUTO FILLED ADDRESS
                                self.cart.BillingAddress.StreetName = data.StreetName;
                                self.cart.BillingAddress.City = data.City;
                                self.manualAddress = false;
                                self.cart.BillingAddress.IsManual = false;
                                self.addressAutofillError = false;
                                //self.addressAutoFilled = true;
                            } else {
                                //self.addressAutoFilled = false;
                            }					
                        } 
                    },
                    error: function(data, status, xhr) {
                        // MANUAL ADDRESS
                        //console.log("ADDRESS: NO ADDRESS FOUND");
                        self.manualAddress = true;
                        self.cart.BillingAddress.IsManual = true;
                        
                        self.addressAutofillError = true;
                        //self.addressAutoFilled = false;
                    }
                });
            }, 100);
        },
        initCompany(){
            var self = this;
            var company = self.cart.BillingAddress.Company;
            
            // SHOW COMPANY INPUT IF THE INPUT HAS VALUE, IF NOT COLLAPSE IT
            if (company !== undefined && company.length >= 0) {
                self.showCompanyLink = true;
            }
        },
        showAndFocusCompany:function(event) {
            var self = this;
            
            // SHOW AND SET FOCUS ON COMPANY INPUT
            var collapseId = event.currentTarget.getAttribute("href");

            $(collapseId).on('shown.bs.collapse', function () {
                self.$refs.inputCompany.focus();
            });
        },
        setDoB(){
            const self = this;
            if (self.cart?.CustomerDateOfBirth !== null && self.cart?.CustomerDateOfBirth !== "") {
                // READ DATE AND SET SELECTED DAY / MONTH / YEAR
                const date = new Date(self.cart?.CustomerDateOfBirth);
                const year = date.getFullYear();
                const month = date.getMonth();
                const day = date.getDate();
                console.log("Date: " + date + ", Day: " + day + ", Month: " + month + ", Year: " + year);
                self.selectedDoB = day; //CustomerDateOfBirth(day)
                self.selectedMoB = month + 1; //CustomerDateOfBirth(month)
                self.selectedYoB = year; //CustomerDateOfBirth(year)
            } 
        },
        changeDoB(){
            const self = this;
            console.log("changed!")
            console.log(self.selectedDoB + "-" + self.selectedMoB + "-" + self.selectedYoB)
            if(
                (self.selectedDoB != 0 ||
                self.selectedMoB != 0 ||
                self.selectedYoB != 0) 
                && (self.selectedDoB == 0 ||
                    self.selectedMoB == 0 ||
                    self.selectedYoB == 0)
            ) {
                console.log("invalid date!");
                self.validDoB = false;
            } else {
                self.validDoB = true;
            }
        },
        initAddressAutocomplete() {
            var self = this;

            var postalCode = self.cart.BillingAddress.PostalCode;
            var number = self.cart.BillingAddress.StreetNumber;
            
            // SHOW ADDRESS SEARCH INPUT (POSTCODE.NL API) IF ADDRESS FIELDS HAVE NO VALUE
            if(postalCode === undefined || postalCode.length <= 0 || number === undefined || number.length <= 0) {
                self.showAutocompleteAddressFieldset = true;
                self.showManualAddressFieldset = false;
            } else {
                self.showAutocompleteAddressFieldset = false;
                self.showManualAddressFieldset = true;
            } 

            var context = "nld";
            
            switch(self.cart.BillingAddress.CountryCode) {
                case "DE":
                    context = "deu";
                    break;
                case "BE":
                    context = "bel";
                    break;
            };

            if ( self.autocomplete !== null && self.autocomplete !== undefined ) {
                self.autocomplete.setCountry(context);
                self.autocomplete.reset();
                // SET FOCUS ON ADDRESS SEARCH INPUT 
                self.$refs.AddressAutoComplete.focus();
            }else{
                // POSTCODE.NL API INPUT
                self.inputElementAddressAutocomplete = document.querySelector('.input-autocomplete-billing'),
                    self.autocomplete = new PostcodeNl.AutocompleteAddress(self.inputElementAddressAutocomplete, {
                        autocompleteUrl: '/api/checkout/billing/street/postcodenl/international/autocomplete', 
                        addressDetailsUrl: '/api/checkout/billing/street/postcodenl/international/autocomplete/details', 
                        language:'nl_NL',
                        context:context
                    });
            }

            // AUTOCOMPLETE-SEARCH: TRIGGERED BEFORE A SEARCH IS PERFORMED. CANCEL THIS EVENT TO PREVENT THE REQUEST FOR ADDRESS SUGGESTIONS.
            self.inputElementAddressAutocomplete.addEventListener('autocomplete-search', function () {
                
                // ADD INFO ALERT TO DROPDOWN (IF IT DOESN'T EXISTS ALREADY)
                if(self.createAutocompleteInfoAlert == true){
                    var suggestions = document.querySelector('.postcodenl-autocomplete-menu');

                    // CREATE ELEMENT
                    var el = document.createElement("div");
                    el.setAttribute("id" , "postcodenl-autocomplet-info-alert");
                    el.setAttribute("class" , "alert alert-info mx-2 mb-2");
                    el.setAttribute("role" , "alert");

                    // ADD TEXT
                    var msg = document.createTextNode(self.autocompleteInfoAlertText);
                    el.appendChild(msg);

                    // INSERT ALERT INSIDE DROPDOWN
                    suggestions.insertBefore(el, suggestions.children[0]);

                    // FALSE: BECAUSE IT'S ALREADY CREATED (THE ELEMENT EXISTS NOW)
                    self.createAutocompleteInfoAlert = false;
                }
            });
            
            // AUTOCOMPLETE-SELECT: TRIGGERED WHEN AN ITEM IS SELECTED FROM THE MENU. SELECTED ITEM DATA IS AVAILABLE ON THE DETAIL PROPERTY OF THE EVENT OBJECT. CANCEL THIS EVENT TO PREVENT UPDATING THE INPUT ELEMENT'S VALUE.
            self.inputElementAddressAutocomplete.addEventListener('autocomplete-select', function (e)  {
                
                if (e.detail.precision === 'Address'){
                    self.autocomplete.getDetails(e.detail.context, function (result) {
                        
                        self.cart.BillingAddress.PostalCode =  result.address['postcode'];
                        self.cart.BillingAddress.City =  result.address['locality'];
                        self.cart.BillingAddress.StreetName =  result.address['street'];
                        self.cart.BillingAddress.StreetNumber =  result.address['buildingNumber'];
                        self.cart.BillingAddress.StreetNumberSuffix =  result.address['buildingNumberAddition'];

                        if (typeof result.mailLines !== 'undefined'){
                            // SHOW THE ADDRESS / HIDE ADDRESS SEARCH INPUT
                            //resultElement.innerHTML = result.mailLines.join('<br>');
                            self.showAutocompleteAddressFieldset = false;
                            self.showManualAddressFieldset = true;   
                        }
                    });
                }
            });

            // AUTOCOMPLETE-CREATE: TRIGGERED WHEN THE AUTOCOMPLETE IS CREATED.
            self.inputElementAddressAutocomplete.addEventListener('autocomplete-create', function () {
            });

            // AUTOCOMPLETE-OPEN: TRIGGERED WHEN THE MENU IS OPENED.
            self.inputElementAddressAutocomplete.addEventListener('autocomplete-open', function () {
            });

            // AUTOCOMPLETE-OPEN: TRIGGERED WHEN THE MENU IS CLOSED.
            self.inputElementAddressAutocomplete.addEventListener('autocomplete-close', function () {
                
                setTimeout(function() {
                    if ( self.cart.BillingAddress.PostalCode == "" || 
                        self.cart.BillingAddress.City == "" ||
                        self.cart.BillingAddress.StreetName == "" || 
                        self.cart.BillingAddress.StreetNumber == "" ) 
                    {
                        // SHOW ERROR: NO VALID ADDRESS SELECTED
                        self.showAutocompleteError = true;
                    }else{
                        // HIDE ERROR: VALID ADDRESS IS SELECTED
                        self.showAutocompleteError = false;
                    }
                }, 1500);
                
            });

            // AUTOCOMPLETE-RESPONSE: TRIGGERED AFTER A SEARCH COMPLETES, BEFORE THE MENU IS SHOWN. RESULT DATA IS AVAILABLE VIA THE DETAIL PROPERTY OF THE EVENT OBJECT. CANCEL THIS EVENT TO PREVENT RENDERING ADDRESS SUGGESTIONS.
            self.inputElementAddressAutocomplete.addEventListener('autocomplete-response', function (e) {
            });

            // AUTOCOMPLETE-ERROR: TRIGGERED WHEN THE REQUEST FOR AUTOCOMPLETE SUGGESTIONS FAILS.
            self.inputElementAddressAutocomplete.addEventListener('autocomplete-error', function (e) {
                console.log('ProgressEvent:', e.detail.event);
	            console.log('XMLHttpRequest:', e.detail.request);
            });
                
        },
        resetAddressAutocomplete() {
            var self = this;

            self.autocomplete.reset();

            if(self.inputElementAddressAutocomplete != null) {
                self.inputElementAddressAutocomplete.value = "";
            }

            self.showAutocompleteError = false;

            // EMPTY ADDRESS INPUTS
            self.cart.BillingAddress.PostalCode =  "";
            self.cart.BillingAddress.City =  "";
            self.cart.BillingAddress.StreetName =  "";
            self.cart.BillingAddress.StreetNumber =  "";
            self.cart.BillingAddress.StreetNumberSuffix =  "";

            // SHOW ADDRESS SEARCH INPUT
            self.showAutocompleteAddressFieldset = true;
            self.showManualAddressFieldset = false;

            // SET FOCUS ON ADDRESS SEARCH INPUT 
            self.$refs.AddressAutoComplete.focus();
        },
        focusPostalCode:function() {
            var self = this;

            // HIDE ADDRESS SEARCH INPUT
            self.showAutocompleteAddressFieldset = false;
            self.showManualAddressFieldset = true;

             // SET FOCUS ON POSTALCODE INPUT
             self.$refs.inputPostalCode.focus();
        },
    },
    computed: {
        addressIsValid: function () {

            var self = this;

            var postalCode = self.cart.BillingAddress.PostalCode;
            var number = self.cart.BillingAddress.StreetNumber;
            var suffix = self.cart.BillingAddress.StreetNumberSuffix;
            
            if (postalCode != null && postalCode.length > 0 && number != null && number.length > 0) {
                return true;
            } else if (postalCode != null && postalCode.length > 0 && number != null && number.length > 0 && suffix != null && suffix.length > 0) {
                return true;
            }else {
                return false;
            } 
        },
        applyManualAddress: function () {
            return this.manualAddress;
        },
        selectedDateOfBirth(){
            const self = this;
            let date;
            if(self.selectedDoB != 0 && self.selectedMoB != 0 && self.selectedYoB != 0){
                date = moment(self.selectedDoB + "-" + self.selectedMoB + "-" + self.selectedYoB, "DD-MM-YYYY").toDate().toJSONLocal();
            }
            else 
                date = null
            return date;
        },
        years () {
            const year = new Date().getFullYear();
            const startYear = year - 101; // 100 years ago
            return Array.from({length: year - startYear}, (value, index) => year - index)
        },
        months () {
            return [
                {
                    value: 1,
                    title: "januari"
                },
                {
                    value: 2,
                    title: "februari"
                },
                {
                    value: 3,
                    title: "maart"
                },
                {
                    value: 4,
                    title: "april"
                },
                {
                    value: 5,
                    title: "mei"
                },
                {
                    value: 6,
                    title: "juni"
                },
                {
                    value: 7,
                    title: "juli"
                },
                {
                    value: 8,
                    title: "augustus"
                },
                {
                    value: 9,
                    title: "september"
                },
                {
                    value: 10,
                    title: "oktober"
                },
                {
                    value: 11,
                    title: "november"
                },
                {
                    value: 12,
                    title: "december"
                }
            ]
        },
        days () {
            return Array.from({length: 31 - 0}, (value, index) => 1 + index)
        }
    },
    mounted: function() {
        // vuedlhelper.checkout(3);
        vuedlhelper.begin_checkout(this.cart);
        this.setDoB();
        this.initCompany();
        
       
        if(this.cart?.BillingAddress?.CountryCode == null || this.cart?.BillingAddress?.CountryCode == "") {
            this.cart.BillingAddress.CountryCode = _config.selectedCountry;

            this.countryChanged();
        }else {
            this.initAddressAutocomplete();
        }
    }
});

Vue.component('shipping-component', {
    template: '#shipping-template',
    props: {
        cart: {
            type: Object,
            function () {
                return { ShippingAddress: {
                        FirstName: "",
                        Infix: "",
                        LastName: "",
                        StreetName: "",
                        StreetNumber:"",
                        StreetNumberSuffix : "",
                        PostalCode: "",
                        City: "",
                        CountryCode: "",
                        Country: "",
                        IsManual: "",
                    } 
                }
            }
        }
    },
    data() {
        return {
            siteCulture: _config.siteCulture,
            methods: [ 
                { 
                    Name:"Delivery", 
                    Id: "radioDelivery", 
                    Title: "Bezorgen", 
                    Description: "Thuis of op een ander adres",
                    Countries: ["NL", "BE", "DE"],
                    Carriers: [
                        { 
                            Value: "PostNL", 
                            Name: "PostNL", 
                            Type: "Standaard pakket",
                            Countries: ["NL" , "BE"],
                            Logo: "/images/logo-postnl.png",
                            Description: "Deze bestelling wordt geleverd door PostNL",
                            Extra: {
                                Title: "Extra opties PostNL",
                                Countries: ["NL"],
                                Options: [
                                    {
                                        Name: "SignForDelivery",
                                        Title: "Handtekening bij ontvangst",
                                        Description: "",
                                        Note: "",
                                        Value: "",
                                        Countries: ["NL"]
                                    },
                                    {
                                        Name: "NoDeliveryAtNeighbours",
                                        Title: "Niet leveren bij de buren",
                                        Description: "",
                                        Note: "",
                                        Value: "",
                                        Countries: ["NL"]
                                    },
                                    {
                                        Name: "EveningDelivery",
                                        Title: "Avondlevering",
                                        Description: "",
                                        Note: "(levering na 18:00)",
                                        Value: "",
                                        Countries: ["NL"]
                                    },
                                ]
                            }
                        },
                        { 
                            Value: "DHL", 
                            Name: "DHL",
                            Type: "DFY",
                            Countries: ["NL", "DE"],
                            Logo: "/images/logo-dhl.png",
                            Description: "Deze bestelling wordt geleverd door DHL",
                            Extra: {
                                Title: "Extra opties DHL",
                                Countries: ["NL"],
                                Options: [
                                    {
                                        Name: "SignForDelivery",
                                        Title: "Handtekening bij ontvangst",
                                        Description: "",
                                        Note: "",
                                        Value: "",
                                        Countries: ["NL"]
                                    },
                                    {
                                        Name: "NoDeliveryAtNeighbours",
                                        Title: "Niet leveren bij de buren",
                                        Description: "",
                                        Note: "",
                                        Value: "",
                                        Countries: ["NL"]
                                    },
                                    {
                                        Name: "EveningDelivery",
                                        Title: "Avondlevering",
                                        Description: "",
                                        Note: "(levering na 18:00)",
                                        Value: "",
                                        Countries: ["NL"]
                                    },
                                ]
                            }
                        },
                    ],
                    Costs: {
                        NL: 5.95,
                        BE: 5.95,
                        DE: 6.95
                    }
                },
                { 
                    Name:"pickup_store", 
                    Id: "radioPickupStore", 
                    Title: "Afhalen in de winkel",
                    Description: "Ophalen bij Broeders Gezondheidswinkel",
                    Countries: ["NL"],
                    Costs: {
                        NL: 0,
                        BE: 0,
                        DE: 0
                    },
                    Stores: [
                        {
                            Name: "Broeders Gezondheidswinkel",
                            StreetName: "Keiweg",
                            StreetNumber: "7",
                            PostalCode: "4901JD",
                            City: "Oosterhout",
                            Country: "Nederland",
                            CountryCode: "NL",
                            OpeningHours: [
                                {
                                    Monday: [
                                        {
                                            Open: true,
                                            OpensAt: "11:00",
                                            ClosesAt: "18:00"
                                        }
                                    ],
                                    Tuesday: [
                                        {
                                            Open: true,
                                            OpensAt: "9:00",
                                            ClosesAt: "18:00"
                                        }
                                    ],
                                    Wednesday: [
                                        {
                                            Open: true,
                                            OpensAt: "9:00",
                                            ClosesAt: "18:00"
                                        }
                                    ],
                                    Thursday: [
                                        {
                                            Open: true,
                                            OpensAt: "9:00",
                                            ClosesAt: "18:00"
                                        }
                                    ],
                                    Friday: [
                                        {
                                            Open: true,
                                            OpensAt: "9:00",
                                            ClosesAt: "21:00"
                                        }
                                    ],
                                    Saturday: [
                                        {
                                            Open: true,
                                            OpensAt: "8:30",
                                            ClosesAt: "17:00"
                                        }
                                    ],
                                    Sunday: [
                                        {
                                            Open: false,
                                            OpensAt: "0:00",
                                            ClosesAt: "0:00"
                                        }
                                    ],
                                }
                            ]
                        }
                    ],
                },
                { 
                    Name:"pickup_location", 
                    Id: "radioPickupLocation", 
                    Title: "Afhaalpunt", 
                    Description: "Ophalen bij afhaalpunt",
                    // Countries: ["NL", "BE", "DE"],
                    Countries: ["NL"], // Temp. only in The Netherlands
                    Costs: {
                        NL: 5.95,
                        BE: 5.95,
                        DE: 6.95
                    },
                    Carriers: [
                        { 
                            Value: "PostNL", 
                            Name: "PostNL", 
                            Type: "Standaard pakket",
                            Logo: "/images/logo-postnl.png",
                            Description: "PakjeGemak; afhalen bij PostNL afhaalpunt",
                            Countries: ["NL", "BE"],
                            Extra: {
                                Countries: ["NL", "BE"],
                            }
                        },
                        { 
                            Value: "DHL", 
                            Name: "DHL",
                            Type: "DFY",
                            Logo: "/images/logo-dhl.png",
                            Description: "Afhalen bij een DHL ServicePoint",
                            Countries: ["NL", "DE"],
                            Extra: {
                                Countries: ["NL", "DE"],
                            }
                        },
                    ],
                }
            ],   
            countries: _config.countries,
            carriers: [
                { 
                    Value: "PostNL", 
                    Name: "PostNL", 
                    Type: "Standaard pakket",
                    Countries: ["NL", "BE"]
                },
                { 
                    Value: "DHL", 
                    Name: "DHL",
                    Type: "DFY",
                    Countries: ["NL", "DE"]
                },
            ],
            noMethodSelected: false,
            selectedShippingCarrier: "DHL",
            selectedPickupCarrier: "DHL",
            pickupPostalCode: "",
            pickupHouseNumber: "",
            pickupLocations: [],
            selectedPickupLocationData: [],
            selectedPickupLocation: "",
            showPickupData: false,
            showPickupError: false,
            editAddress: false,
            editPickup: false,
            editLocation: false,
            setLocation: false,
            manualAddress: false,
            addressAutoFilled: false,
            addressAutofillError: false,
            addressAutofillErrorText: _addressAutofillAlertText,
            sameAddress: true,
            postalCodeCheck: true,
            isPending: false,
            NotOrderableForSelectedCountryBilling: this.cart.NotOrderableForSelectedCountryBilling,
            NotOrderableForSelectedCountryShipping: this.cart.NotOrderableForSelectedCountryShipping,
            billingMethodTitle: _billingMethodTitle,
            billingAddressHeading: _billingAddressHeading,
            shippingAddressHeading: _shippingAddressHeading,
            deliveryOnAltAddressLink: _deliveryOnAltAddressLink,
            editShippingAddressLink: _editShippingAddressLink,
            sameAddressLink: _sameAddressLink,
            companyLink: _companyLink,
            showCompanyLink: false,
            inputHouseNumberLabel: _inputHouseNumberLabel,
            btnTextPrev: _btnTextPrev,
            btnTextProceed: _btnTextProceed,
            showBottomBar: false
        }
    },
    methods: {
        visibilityChanged: function(isVisible) {
            this.showBottomBar = !isVisible
        },
        updateShippingMethod: function() {
            var self = this;
            var shippingMethod = this.cart.ShippingMethod;
            var pickupStore = shippingMethod === "pickup_store";
            var carrier = this.cart.Carrier;

            jQuery.ajax({
                url:"/api/checkout/shipping/method/", 
                type:"post", 
                dataType:"json", 
                context:this, 
                data: {
                    ShippingMethod: shippingMethod,
                    Carrier: this.cart.Carrier ? this.cart.Carrier : null
                },
                success: function(data, status, xhr) {
                    //this.$emit('cart-changed');
                    var option = shippingMethod;
                    if(shippingMethod && carrier && !pickupStore) {
                        if(shippingMethod === "pickup_location"){
                            shippingMethod = "Pickup Locatie";
                        }

                        option = shippingMethod + " - " + carrier;
                    }
                    // vuedlhelper.checkout_option(4, option);
                    vuedlhelper.add_shipping_info(this.cart, option);
                    if(pickupStore) {
                        this.setLocation = false;
                        this.setPickupStoreAddress();
                    }
                    this.$emit('cart-changed');
                },
                complete: function(xhr, status) {
                },
                error: function(error, status, xhr) {
                    console.log(error);
                }
            });
        },
        
        updateExtraShippingOption: function(e){
            var name = e.target.name;
            this.cart[name] = e.target.checked;
        },
        updatePickupCountry: function() {
            this.showPickupData = false;
            this.$emit('clear-options');				
        },
        updateCarrier: function() {
            this.updateShippingMethod();
            this.showPickupData = false;
            this.$emit('clear-options');				
        },
        updatePickupCarrier: function() {
            this.showPickupData = false;
            this.$emit('clear-options');				
        },
        saveAddress: function() {
            var self = this;
            self.cart.ShippingAddress.IsManual = self.manualAddress;
            jQuery.ajax({
                url:"/api/checkout/shipping/address/", 
                type:"post", 
                dataType:"json", 
                context:this, 
                data: this.cart.ShippingAddress,
                success: function(data, status, xhr) {
                    self.editAddress = false;
                    this.$emit('cart-changed');
                },
                complete: function(xhr, status) {
                },
                error:  function(error, status, xhr) {
                    console.log(error);
                }
            });
            
        },
        editAltAddress: function(){
            this.editAddress = true;
            this.sameAddress = false;
            this.initCompany();
            this.sameAddressChanged();
        },
        cancelEditAltAddress: function(){
            this.editAddress = false;
            this.sameAddress = true;
            this.sameAddressChanged();
        },
        syncAddress: function() {
            this.cart.ShippingAddress.Salutation = this.cart.BillingAddress.Salutation;
            this.cart.ShippingAddress.FirstName = this.cart.BillingAddress.FirstName;
            this.cart.ShippingAddress.Infix = this.cart.BillingAddress.Infix;
            this.cart.ShippingAddress.LastName = this.cart.BillingAddress.LastName;
            this.cart.ShippingAddress.StreetName = this.cart.BillingAddress.StreetName;
            this.cart.ShippingAddress.StreetNumber = this.cart.BillingAddress.StreetNumber;
            this.cart.ShippingAddress.StreetNumberSuffix = this.cart.BillingAddress.StreetNumberSuffix;
            this.cart.ShippingAddress.City = this.cart.BillingAddress.City;
            this.cart.ShippingAddress.PostalCode = this.cart.BillingAddress.PostalCode;
            this.cart.ShippingAddress.CountryCode = this.cart.BillingAddress.CountryCode;
            this.cart.ShippingAddress.Country = this.cart.BillingAddress.Country;
            this.saveAddress();
        },
        sameAddressChanged: function() {
            if(this.sameAddress) {
                this.cart.ShippingAddress.Salutation = this.cart.BillingAddress.Salutation;
                this.cart.ShippingAddress.FirstName = this.cart.BillingAddress.FirstName;
                this.cart.ShippingAddress.Infix = this.cart.BillingAddress.Infix;
                this.cart.ShippingAddress.LastName = this.cart.BillingAddress.LastName;
                this.cart.ShippingAddress.StreetName = this.cart.BillingAddress.StreetName;
                this.cart.ShippingAddress.StreetNumber = cart.BillingAddress.StreetNumber;
                this.cart.ShippingAddress.StreetNumberSuffix = cart.BillingAddress.StreetNumberSuffix;
                this.cart.ShippingAddress.City = this.cart.BillingAddress.City;
                this.cart.ShippingAddress.PostalCode = this.cart.BillingAddress.PostalCode;
                this.cart.ShippingAddress.CountryCode = this.cart.BillingAddress.CountryCode;
                this.cart.ShippingAddress.Country = this.cart.BillingAddress.Country;
            }
        },
        countryChanged:function() {
            var self = this;
            var country = $.grep(this.countries, function (c) {
                return c.Code == self.cart.ShippingAddress.CountryCode;
            })[0];    

            this.cart.ShippingAddress.Country = country.Name;
        },
        initCompany(){
            var self = this;
            var company = self.cart.ShippingAddress.Company;
            
            // SHOW COMPANY INPUT IF THE INPUT HAS VALUE, IF NOT COLLAPSE IT
            if (company !== undefined && company.length >= 0) {
                self.showCompanyLink = true;
            }
        },
        showAndFocusCompany:function(event) {
            var self = this;
            
            // SHOW AND SET FOCUS ON COMPANY INPUT
            var collapseId = event.currentTarget.getAttribute("href");
        
            $(collapseId).on('shown.bs.collapse', function () {
                self.$refs.inputEditCompany[0].focus();
            });
        },
        save: function() {
            var self = this;
            var method = this.cart.ShippingMethod;
            self.isPending = true;
            
            jQuery.ajax({
                url:"/api/checkout/shipping/method/", 
                type:"post", 
                dataType:"json", 
                context:this, 
                data:{ 
                    ShippingMethod:method,
                    NoDeliveryAtNeighbours: this.cart.NoDeliveryAtNeighbours,
                    EveningDelivery: this.cart.EveningDelivery,
                    SignForDelivery: this.cart.SignForDelivery,
                    Carrier: this.cart.Carrier
                },
                success: function(data, status, xhr) { 
                    if (status == "success") {
                        self.$emit('next');
                    }
                },
                complete: function(xhr, status) {
                    self.isPending = false;
                    store.scrollToTop();

                    // VUE / BOOTSTRAP CONFLICT WORKAROUND:
                    // Placed to AJAX success or complete handler, after the DOM manipulation. 
                    // To ensure the DOM is updated, the 'nextTick function' is used
                    Vue.nextTick(function () {
                        // REMOVE UNWANTED SURROUNDING '<p>...</p>' TAGS, PLACED BY CONTENT EDITOR
                        $( ".js-strip-p" ).each( function() {
                            var pTags = $(this).children("p:first");

                            if (typeof pTags !== typeof undefined && pTags !== false) {
                                $(this).find(pTags).contents().unwrap();
                            }
                        });
                    });
                }
            });
        },
        prev:function() {
            var self = this;
            self.isPending = true;
            store.scrollToTop();
            self.$emit('prev'); 
        },
        getPickupLocations() {
            var self = this;
            var postalcode = this.pickupPostalCode ? this.pickupPostalCode : "";
            postalcode = postalcode.replace(/\s/g,'');
            var housenumber = this.pickupHouseNumber ? this.pickupHouseNumber : "1";
            var carrier = this.cart.Carrier;
            var buCountryCode = this.cart.ShippingAddress.CountryCode ? this.cart.ShippingAddress.CountryCode : this.cart.BillingAddress.CountryCode;
            var countryCode = this.cart.PickupAddress.CountryCode ? this.cart.PickupAddress.CountryCode : buCountryCode;
            jQuery.ajax({
                url:"api/checkout/shipping/pickup/" + postalcode + "?HouseNumber=" + housenumber + "&Carrier=" + carrier + "&CountryCode=" + countryCode, 
                type:"get", 
                dataType:"json",
                success: function(data, status, xhr) {
                    if (status == "success") {
                        if(data.Locations) {
                            self.selectedPickupLocationData = data.Locations[0];
                            self.selectedPickupLocation = data.Locations[0].Name;
                            self.pickupLocations = data;
                            self.showPickupData = true;
                            self.showPickupError = false;
                        } else {
                        }					
                    } 
                },
                error:  function(error, status, xhr) {
                    console.log(error);
                    self.showPickupData = false;
                    self.showPickupError = true;
                }
            });
        },
        changePickupLocation: function() {
            var self = this;
            var selected = self.selectedPickupLocation;
            var locList = self.pickupLocations;
            if(locList.Locations.length>0) {
                for(var i=0;i<locList.Locations.length;i++) {
                    if (selected === locList.Locations[i].Name) {
                        self.selectedPickupLocationData = locList.Locations[i];
                    }
                }
            }
        },
        setPickupStoreAddress: function() {
            this.cart.PickupAddress.Country = "Nederland";
            this.cart.PickupAddress.CountryCode = "NL";
            this.cart.PickupAddress.Company = "Broeders Gezondheidswinkel";
            this.cart.PickupAddress.Name = "Broeders Gezondheidswinkel";
            this.cart.PickupAddress.StreetName = "Keiweg";
            this.cart.PickupAddress.StreetNumber = "7";
            this.cart.PickupAddress.StreetNumberSuffix = "";
            this.cart.PickupAddress.PostalCode = "4901JD";
            this.cart.PickupAddress.City = "Oosterhout";
            this.cart.PickupAddress.PostalCodeNumeric = "4901";
            this.cart.PickupAddress.PostalCodeAlpha = "JD";

            jQuery.ajax({
                url: "/api/checkout/shipping/pickup/", 
                type: "post", 
                dataType: "json", 
                context: this, 
                data:{
                    ShippingMethod: "pickup_store",
                    //Carrier: this.cart.Carrier ? this.cart.Carrier : null,
                    Country: this.cart.PickupAddress.Country = "Nederland",
                    CountryCode: this.cart.PickupAddress.CountryCode = "NL",
                    LocationCode: "",
                    Company: this.cart.PickupAddress.Company = "Broeders Gezondheidswinkel",
                    //Address: this.selectedPickupLocationData ? this.selectedPickupLocationData.Address : null,
                    StreetName: this.cart.PickupAddress.StreetName = "Keiweg",
                    StreetNumber: this.cart.PickupAddress.StreetNumber = "7",
                    StreetNumberSuffix: this.cart.PickupAddress.StreetNumberSuffix = "",
                    PostalCode: this.cart.PickupAddress.PostalCode = "4901JD",
                    City: this.cart.PickupAddress.City = "Oosterhout",
                    PostalCodeNumeric: this.cart.PickupAddress.PostalCodeNumeric = "4901",
                    PostalCodeAlpha: this.cart.PickupAddress.PostalCodeAlpha = "JD",
                    ProductCode: "",
                    LocationType: "Winkel"
                },
                success: function(data, status, xhr) {
                    this.$emit('cart-changed');
                }
            })
        },
        setPickupLocation: function() {
            var selectedPickupLocationData = this.selectedPickupLocationData;
            var sm = this.cart.ShippingMethod;
            
            this.cart.PickupAddress.Country = this.cart.PickupAddress.Country;
            this.cart.PickupAddress.CountryCode = this.cart.PickupAddress.CountryCode;
            this.cart.PickupAddress.Company = this.selectedPickupLocationData.Name;
            this.cart.PickupAddress.Name = this.selectedPickupLocationData.Name;
            this.cart.PickupAddress.StreetName = this.selectedPickupLocationData.StreetName;
            this.cart.PickupAddress.StreetNumber = this.selectedPickupLocationData.StreetNumber;
            this.cart.PickupAddress.StreetNumberSuffix = this.selectedPickupLocationData.StreetNumberSuffix;
            this.cart.PickupAddress.PostalCode = this.selectedPickupLocationData.PostalCode;
            this.cart.PickupAddress.City = this.selectedPickupLocationData.City;
            this.cart.PickupAddress.PostalCodeNumeric = this.selectedPickupLocationData.PostalCodeNumeric;
            this.cart.PickupAddress.PostalCodeAlpha = this.selectedPickupLocationData.PostalCodeAlpha;

            var cc = this.cart.PickupAddress.CountryCode;

            if (cc === "NL"){
                this.cart.PickupAddress.Country = "Nederland";
            }

            if (cc === "BE"){
                this.cart.PickupAddress.Country = "België";
            }
            
            if (cc === "DE"){
                this.cart.PickupAddress.Country = "Duitsland";
            }

            jQuery.ajax({
                url: "/api/checkout/shipping/pickup/", 
                type: "post", 
                dataType: "json", 
                context: this, 
                data:{
                    ShippingMethod: "pickup_location",
                    Carrier: this.cart.Carrier ? this.cart.Carrier : null,
                    Country: this.cart.PickupAddress.Country ? this.cart.PickupAddress.Country : null,
                    CountryCode: this.cart.PickupAddress.CountryCode ? this.cart.PickupAddress.CountryCode : null,
                    LocationCode: this.selectedPickupLocationData ? this.selectedPickupLocationData.Code : null,
                    Company: this.selectedPickupLocationData ? this.selectedPickupLocationData.Name : null,
                    //Address: this.selectedPickupLocationData ? this.selectedPickupLocationData.Address : null,
                    StreetName: this.selectedPickupLocationData ? this.selectedPickupLocationData.StreetName : null,
                    StreetNumber: this.selectedPickupLocationData ? this.selectedPickupLocationData.StreetNumber : null,
                    StreetNumberSuffix: this.selectedPickupLocationData ? this.selectedPickupLocationData.StreetNumberSuffix : null,
                    PostalCode: this.selectedPickupLocationData ? this.selectedPickupLocationData.PostalCode : null,
                    City: this.selectedPickupLocationData ? this.selectedPickupLocationData.City : null,
                    PostalCodeNumeric: this.selectedPickupLocationData ? this.selectedPickupLocationData.PostalCodeNumeric : null,
                    PostalCodeAlpha: this.selectedPickupLocationData ? this.selectedPickupLocationData.PostalCodeAlpha : null,
                    ProductCode: this.selectedPickupLocationData ? this.selectedPickupLocationData.ProductCode : null,
                    LocationType: this.selectedPickupLocationData ? this.selectedPickupLocationData.LocationType : null
                },
                success: function(data, status, xhr) {
                    this.editLocation = false;
                    this.setLocation = true;
                    this.$emit('cart-changed');
                    //this.updateSelectedPickupAddress();
                }
            })
        },
        checkAddress: function () {

            var self = this;

            if(!self.postalCodeCheck){
                return
            }

            
            if(self.cart.ShippingAddress.CountryCode !== 'NL') {
                checkout.test = true;
                return;
            }
            
            self.cart.ShippingAddress.StreetName = "";
            self.cart.ShippingAddress.City = "";
            var postalCode = self.cart.ShippingAddress.PostalCode;
            var number = self.cart.ShippingAddress.StreetNumber;
            var suffix = self.cart.ShippingAddress.StreetNumberSuffix;
            jQuery.ajax({
                url:"/api/checkout/billing/street/?PostalCode=" + postalCode + "&StreetNumber=" + number + "&StreetNumberSuffix=" + suffix , 
                type:"get", 
                dataType:"json",
                success: function(data, status, xhr) {
                    if (status == "success") {
                        if(data.Success) {
                            self.cart.ShippingAddress.StreetName = data.StreetName;
                            self.cart.ShippingAddress.City = data.City;
                            self.manualAddress = false;
                            self.addressAutofillError = false;
                        } else {
                        }					
                    } 
                },
                error: function(data, status, xhr) {							
                    self.manualAddress = true;
                    self.addressAutofillError = true;
                }
                
            });
        }
    },
    computed: {
        isAvailableMethod: function(countries) {
            return countries.includes(this.cart.ShippingAddress.CountryCode);
        },
        isFreeShipping: function() {
            if(this.cart.ShippingMethod == "Delivery"){
                if(this.cart.ShippingAddress.CountryCode == "NL")
                    return this.cart.GrossTotal >= 50;

                if(this.cart.ShippingAddress.CountryCode == "BE")
                    return this.cart.GrossTotal >= 100;

                if(this.cart.ShippingAddress.CountryCode == "DE")
                    return this.cart.GrossTotal >= 100;
            }
                
            if(this.cart.ShippingMethod == "pickup_location"){
                if(this.cart.PickupAddress.CountryCode == "NL")
                    return this.cart.GrossTotal >= 50;

                if(this.cart.PickupAddress.CountryCode == "BE")
                    return this.cart.GrossTotal >= 100;

                if(this.cart.PickupAddress.CountryCode == "DE")
                    return this.cart.GrossTotal >= 100;
            }

            return this.cart.GrossTotal >= 50;
        },
        locationSet: function() {
            const self = this;
            let status = false;
            if(self.cart.PickupAddress.Code != undefined && self.cart.PickupAddress.Code != "")
                status = true
            return status;
        },
        addressIsValid: function () {
            var self = this;
            var postalCode = self.cart.BillingAddress.PostalCode;
            var number = self.cart.BillingAddress.StreetNumber;
            var suffix = self.cart.BillingAddress.StreetNumberSuffix;
            
            if (postalCode != null && postalCode.length > 0 && number != null && number.length > 0) {
                return true;
             } else if (postalCode != null && postalCode.length > 0 && number != null && number.length > 0 && suffix != null && suffix.length > 0) {
                return true;
            } else {
                return false;
            }
        },
        applyManualAddress: function () {
            return this.manualAddress;
        },
        deliverySelected: function () {
            return this.cart.ShippingMethod == "Delivery";
        },
        pickupSelected: function () {
            return this.cart.ShippingMethod == "pickup_store";
        },
        locationSelected: function () {
            //return this.cart.ShippingMethod == "PAKJEGEMAK_NOTIFICATION";
            return this.cart.ShippingMethod == "pickup_location";
        },
        isNL: function() {
                return this.cart.ShippingAddress && this.cart.ShippingAddress.CountryCode == "NL";
        },
        isBE: function() {
            return this.cart.ShippingAddress && this.cart.ShippingAddress.CountryCode == "BE";
        },
        isDE: function() {
            return this.cart.ShippingAddress && this.cart.ShippingAddress.CountryCode == "DE";
        },
        enabled: function () {
            return true;
        },
        valid: function() {
            if(this.cart.ShippingMethod.length == 0)
                return false;

            if(this.cart.ShippingMethod == "pickup_store")
                return true;
            
            if(this.cart.ShippingMethod == "pickup_location" && this.setLocation) {
                return true;
            } else if (this.cart.ShippingMethod == "pickup_location" && !this.setLocation) {
                return false;
            } 

            return this.cart.ShippingAddress.FirstName != null && this.cart.ShippingAddress.FirstName.length > 0 
                && this.cart.ShippingAddress.LastName != null && this.cart.ShippingAddress.LastName.length > 0 
                && this.cart.ShippingAddress.StreetName != null && this.cart.ShippingAddress.StreetName.length > 0 
                && this.cart.ShippingAddress.StreetNumber != null && this.cart.ShippingAddress.StreetNumber.length > 0 
                && this.cart.ShippingAddress.City != null && this.cart.ShippingAddress.City.length > 0 
                && this.cart.ShippingAddress.PostalCode != null && this.cart.ShippingAddress.PostalCode.length > 0 
                && this.cart.ShippingAddress.CountryCode != null && this.cart.ShippingAddress.CountryCode.length > 0;
        },
        isSameAddress: function(){
            var sa = [{
                "1": this.cart.ShippingAddress.StreetName,
                "2": this.cart.ShippingAddress.StreetNumber,
                "3": this.cart.ShippingAddress.City,
                "4": this.cart.ShippingAddress.PostalCode,
                "5": this.cart.ShippingAddress.Country,
                "6": this.cart.ShippingAddress.CountryCode
            }];
            var ba = [{
                "1": this.cart.BillingAddress.StreetName,
                "2": this.cart.BillingAddress.StreetNumber,
                "3": this.cart.BillingAddress.City,
                "4": this.cart.BillingAddress.PostalCode,
                "5": this.cart.BillingAddress.Country,
                "6": this.cart.BillingAddress.CountryCode
            }];
            return JSON.stringify(sa) === JSON.stringify(ba);
        },
    },
    created: function() {
        //vuedlhelper.checkout_option(3, this.cart.ShippingMethod);
        this.$emit('cart-changed');
        this.editAddress = false;
        var shippingMethod = this.cart.ShippingMethod;
        var carrier = this.cart.Carrier;
        var option = shippingMethod;

        if(shippingMethod && carrier){
            option = shippingMethod + " - " + carrier;
        }
        // vuedlhelper.checkout_option(4, option);
        vuedlhelper.add_shipping_info(this.cart, option);

    }
});

Vue.component('payment-component', {
    template: '#payment-template',
    props: {
        cart: {
            type: Object
        },
        cartValid: Boolean,
        paymentError: Boolean,
        authenticated: Boolean,
        executingOrder: Boolean
    },
    data() {
        return {
            siteCulture: _config.siteCulture,
            remarks: "",
            remarksDescription: _remarksDescription,
            remarksInputLabelText: _textareaRemarksLabelText,
            remarksInputPlaceholderText: _textareaRemarksPlaceholderText,
            noMethodSelected: false,
            selectedMethod: "",
            methods: _config.PaymentMethods,
            activeClass:'active',
            checkoutPrivacyFootnoteText: _checkoutPrivacyFootnoteText,
            optIn: store.SubscribeNewsletter,
            optinCheckboxLabelText: _optinCheckboxLabelText,
            hideOptinCheckbox: store.hideOptinCheckbox,
            roles: store.Roles[0],
            isPending: false,
            saving: false,
            btnTextPrev: _btnTextPrev,
            btnTextPay: _btnTextPay,
            showBottomBar: false
        }
    },
    methods: {
        visibilityChanged: function(isVisible) {
            this.showBottomBar = !isVisible
        },
        methodChanged: function() {
            var self = this;
            self.noMethodSelected = false;
            self.selectedMethod = self.cart.PaymentMethod;
            var paymentMethod = this.cart.PaymentMethod;
            var option = "Payment Method " + paymentMethod;

            var method = this.methods.filter(function (m) {
                return m.Name == self.cart.PaymentMethod;
            })[0];

            if(method.Issuers.length == 0) {
                this.cart.BillingMethod = method.Name;
                this.saveMethod();
                // datalayer code
                // vuedlhelper.checkout_option(5, option);
                vuedlhelper.add_payment_info(this.cart, option);
            }else {
                this.cart.BillingMethod = "";
                var issuerTitle = null;
                var issuers = method.Issuers.filter(function (m) {
                    return m.Name == self.cart.BillingMethod;
                });
                if (issuers.length > 0)
                    issuerTitle = issuers[0].Title;
                // datalayer code
                if (paymentMethod && issuerTitle) {
                    option = "Payment Method " + paymentMethod + " - " + issuerTitle;
                    // vuedlhelper.checkout_option(5, option);
                    vuedlhelper.add_payment_info(this.cart, option);
                }
            }
                
            this.$emit('payment-changed', this.cart);
        },
        issuerChanged: function(e) {
            this.noMethodSelected = false;
            //console.log(e.target.value);
            //issuer.Selected = true;
            this.saveMethod();
            //this.$emit('payment-changed', this.cart);

            // datalayer code
            var paymentMethod = this.cart.PaymentMethod;
            var issuer = e.target.dataset.title;
            var option = "Payment Method " + paymentMethod;
            if(paymentMethod && issuer) {
                option = "Payment Method " + paymentMethod + " - " + issuer;
                // vuedlhelper.checkout_option(5, option);
                vuedlhelper.add_payment_info(this.cart, option);
            }
            if(paymentMethod && !issuer) {
                // vuedlhelper.checkout_option(5, option);
                vuedlhelper.add_payment_info(this.cart, option);
            }

                
        },
        issuerSelected: function(issuer) {
            return this.cart.BillingMethod == issuer.Name;
        },
        prev:function() {
            var self = this;
            self.isPending = true;
            store.scrollToTop();
            self.$emit('prev'); 
        },
        saveMethod: function() {
            var self = this;
            var method = this.cart.BillingMethod
            jQuery.ajax({
                url:"/api/checkout/billing/method/", 
                type:"post", 
                dataType:"json", 
                context:this, 
                data:{ 
                    BillingMethod:method 
                },
                success: function(data, status, xhr) { 
                    if (status == "success") {
                        self.$emit('payment-changed', this.cart);                            
                    }
                }
            }); 
        },
        save: function() {
            var self = this;
            self.isPending = true;
            if (self.executingOrder || self.saving){
                self.isPending = false;
                return;
            }
            self.saving = true;
            self.noMethodSelected = false;
            if(!self.cartValid) {
                if(self.cart.BillingMethod === undefined || self.cart.BillingMethod.length == 0){
                    self.noMethodSelected = true;
                }
                self.saving = false;
                self.isPending = false;
                return;
            }
            var method = this.cart.BillingMethod;
            jQuery.ajax({
                url:"/api/checkout/billing/method/", 
                type:"post", 
                dataType:"json", 
                context:this, 
                data:{ 
                    BillingMethod:method 
                },
                success: function(data, status, xhr) { 
                    if (status == "success") {
                        self.$emit('next', self.remarks, self.optIn);   							
                    }
                    self.saving = false;
                },
                complete: function(xhr, status) {
                    self.isPending = false;
                }
            });
            
        },
        handleVoucherChanged: function() {
            this.$emit('cart-changed');
        }, 
        handleLoyaltyChanged: function() {
            this.$emit('cart-changed');
        },
        showApplePay: function() { 
          
            // Get the user-agent string 
            let userAgentString =  
                navigator.userAgent; 
          
            // Detect Chrome 
            let chromeAgent =  
                userAgentString.indexOf("Chrome") > -1; 
          
            // Detect Internet Explorer 
            let IExplorerAgent =  
                userAgentString.indexOf("MSIE") > -1 ||  
                userAgentString.indexOf("rv:") > -1; 
          
            // Detect Firefox 
            let firefoxAgent =  
                userAgentString.indexOf("Firefox") > -1; 
          
            // Detect Safari 
            let safariAgent =  
                userAgentString.indexOf("Safari") > -1; 
                  
            // Discard Safari since it also matches Chrome 
            if ((chromeAgent) && (safariAgent))  
                safariAgent = false; 
          
            // Detect Opera 
            let operaAgent =  
                userAgentString.indexOf("OP") > -1; 
                  
            // Discard Chrome since it also matches Opera      
            if ((chromeAgent) && (operaAgent))  
                chromeAgent = false; 
          
            return safariAgent
        }
    },
    computed: {
        enabled: function () {
            if(!this.cart || !this.cart.BillingAddress){
                return false;
            }

            return this.cart.BillingAddress.FirstName != null && this.cart.BillingAddress.FirstName.length > 0
                && this.cart.BillingAddress.LastName != null  &&   this.cart.BillingAddress.LastName.length > 0
                && this.cart.ShippingMethod.length > 0;
        },
        needsBankSelection: function() {
            var self = this;
            if(self.cart.PaymentMethod == "IDEAL"){
                return true
            }else {
                return false
            }
        },
        
    },
    mounted: function () {
        this.selectedMethod = this.cart.PaymentMethod;

        var self = this;

        if(!this.showApplePay()){
            var id = "APPLEPAY";

            for(var i = 0; i < self.methods.length; i++) {
                if(self.methods[i].Name == id) {
                    self.methods.splice(i, 1);
                    break;
                }
            }
        }

        var method = self.methods.filter(function (m) {
            return m.Name == self.cart.PaymentMethod;
        })[0];
        var paymentMethod = self.cart.PaymentMethod;
        var option = "Payment Method " + paymentMethod;
        if(method.Issuers.length == 0) {
            this.cart.BillingMethod = method.Name;
            this.saveMethod();
            option = "Payment Method " + paymentMethod;
            // datalayer code
            // vuedlhelper.checkout_option(5, option);
            vuedlhelper.add_payment_info(this.cart, option);
        }
        else {
            var issuerTitle = null;
            var issuers = method.Issuers.filter(function (m) {
                return m.Name == self.cart.BillingMethod;
            });
            if(issuers.length>0)	
                issuerTitle = issuers[0].Title;
            // datalayer code
            if (paymentMethod && issuerTitle) {
                option = "Payment Method " + paymentMethod + " - " + issuerTitle;
                // vuedlhelper.checkout_option(5, option);
                vuedlhelper.add_payment_info(this.cart, option);
            }
        }
        /*
        var paymentMethod = this.cart.PaymentMethod;
        var issuer = this.cart.Carrier;
        if(paymentMethod && issuer)
            var option = "Payment Method " + paymentMethod + " - " + issuer;
        vuedlhelper.checkout_option(3, option);
        */
    },
    created: function() {
        
    }
});

Vue.component('issuer-component', {
    template: '#issuer-template',
    props: {
        issuer: {
            type: Object,
            function () {
                return { }
            }    
        }
    },
    data() {
        return {
            selected:false
        }
    }
});

Vue.component('summary-component', {
    template: '#summary-template',
    props: {
        cart: {
            type: Object,
            function () {
                return { ShippingAddress: {}, BillingAddress: {} }
            }    
        },
        shippingActive: Boolean,
        paymentActive: Boolean,
    },
    data() {
        return {
            shippingActive:  this.shippingActive,
            paymentActive: this.paymentActive
        }
    },
    methods: {
        formatPrice(value) {
            let val = (value/1).toFixed(2).replace('.', ',')
            return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
        },
        removePromoCode:function() {
            var self = this;
            jQuery.ajax({
                url:"/api/checkout/cart/promotion/", 
                type:"delete",
                dataType:"json",
                data:{},
                context:this,
                success: function(data, status, xhr) {
                    this.$emit('cart-changed');
                }
            });
        },	
    },	
});

// Vue.component('confirmation-component', {
//     template: '#confirmation-template',
//     props: {
//         cart: {
//             type: Object
//         },
//         valid: Boolean
//     },
//     data() {
//         return {
//             remarks: '',
//             acceptTerms: false,
//             hasError: false,
//             optIn: store.SubscribeNewsletter
//         }
//     },
//     methods: {
//         execute() {
//             alert(this.cart.PaymentMethod + " " + this.cart.BillingMethod + " " + this.cart.ShippingMethod + " " + this.remarks);
//         }
//     },
//     computed: {
//         isIdeal: function() {
//             return this.valid && this.cart.PaymentMethod == "IDEAL";
//         }
//     }
// });

Vue.component('loyalty-component', {
    template: '#loyalty-template',
    props: {
        cart: {
            type: Object
        },
        authenticated: Boolean
    },
    data: function() {
        return {
            siteCulture: _config.siteCulture,
            ApplyLoyaltyPointsThreshold: 100,
            LoyaltyPointIncrement: 100,
            LoyaltyPointsDiscount: 5,
            ApplyLoyaltyPointsAmount: 100,
            validPoints:false,
            invalidPoints:false,
            minOrderAmountError: false,
            btnTextRedeemLoyaltyPoints: _btnTextRedeemLoyaltyPoints,
            btnTextRemove: _btnTextRemove
        }
    },
    methods: {
        minusLoyaltyPoints: function() {
            let value = this.ApplyLoyaltyPointsAmount;
            if(value > 100) {
                this.ApplyLoyaltyPointsAmount = value -100;
            }
        },
        plusLoyaltyPoints: function() {
            const limit = this.cart.AvailableLoyaltyPoints;
            let value = this.ApplyLoyaltyPointsAmount;
            if(value +100 < limit) {
                this.ApplyLoyaltyPointsAmount = value +100;
            }
        },
        checkLoyaltyPointsAmount: function() {
            var limit = this.cart.AvailableLoyaltyPoints;
            var value = this.ApplyLoyaltyPointsAmount;
            var min = this.ApplyLoyaltyPointsThreshold;

            if(value > limit) {
                var max = Math.round(limit/100)*100;
                this.ApplyLoyaltyPointsAmount = max;

            } else if(value <= limit) {
                var max = Math.round(value/100)*100;

                if (value < min) {
                    this.ApplyLoyaltyPointsAmount = min;
                }else{
                    this.ApplyLoyaltyPointsAmount = max;
                }

                var limitForOrder = this.cart.MaxLoyaltyPointsForOrder;

                if ( limit > limitForOrder) {
                    var maxForOrder = Math.floor(limitForOrder/100)*100;
                    this.cart.MaxLoyaltyPointsForOrder = maxForOrder;
                }
            }
        },
        applyLoyaltyPoints: function() {
            var self =this;
            self.minOrderAmountError = false;
            self.validPoints = false;
            self.invalidPoints = false;
            
            // ROUND NUMBERS UP / DOWN
            self.checkLoyaltyPointsAmount();

            jQuery.ajax({
                url:"/api/checkout/cart/loyaltypoint/", 
                type:"post", 
                dataType:"json",
                data:{
                    UsedLoyaltyPoints:self.ApplyLoyaltyPointsAmount,
                },
                context:this,
                success: function(data, status, xhr) {
                    self.submitting = false;
                    if (status == "success" && data.Success) {
                        self.validPoints = true;
                        self.$emit('loyalty-changed', self.cart);
                    } else {
                        self.invalidPoints= true;

                        if(data.ErrorCode && data.ErrorCode=='MinOrderAmount') {
                           
                            self.minOrderAmountError = true;
                        }
                    };
                }
            });
        },
        removeLoyaltyPoints:function(e) {
            e.preventDefault();
            var self =this;
            self.minOrderAmountError = false;
            self.validPoints = false;
            self.invalidPoints = false;
            jQuery.ajax({
                url:"/api/checkout/cart/loyaltypoint/", 
                type:"post", 
                dataType:"json",
                data:{
                    UsedLoyaltyPoints:0,
                },
                context:this,
                success: function(data, status, xhr) {
                    self.submitting = false;
                    if (status == "success" && data.Success) {
                        self.$emit('loyalty-changed', self.cart);
                    } else {
                    };
                }
            });
        },
        
    },
    computed: {
        canApplyLoyaltyPoint: function() {
            return this.cart.AvailableLoyaltyPoints >= this.ApplyLoyaltyPointsThreshold;
        }
    }
});

Vue.component('voucher-component', {
    template: '#voucher-template',
    props: {
        cart: {
            type: Object
        }
    },
    data: function() {
        return {
            siteCulture: _config.siteCulture,
            code: '',
            validCode: false,
            invalidCode: false,
            submitting: false,
            btnTextActivate: _btnTextActivate,
            btnTextRemove: _btnTextRemove
        }
    },
    methods: {
        checkCode: function(e) {
            if(e){
                e.preventDefault();
            }
            var self = this;
            self.invalidCode= false;
            self.validCode = false;
            self.submitting = true;
            jQuery.ajax({
                url:"/api/checkout/cart/promotion/", 
                type:"post", 
                dataType:"json",
                data:{
                    Code:self.cart.PromotionCode,
                },
                context:this,
                success: function(data, status, xhr) {
                    self.submitting = false;

                    if (status == "success" && data.Success) {
                        self.validCode = true;
                        //self.cart.PromotionCodeValid = true;
                    } else {
                        self.invalidCode= true;
                        //self.cart.PromotionCodeValid = false;
                    };

                    setTimeout(function() {
                        self.$emit('voucher-changed', self.cart);
                    }, 1000);
                }
            });
        },
        removeCode: function(e) {
            if(e){
                e.preventDefault();
            }
            var self = this;
            jQuery.ajax({
                url:"/api/checkout/cart/promotion/", 
                type:"delete", 
                dataType:"json",
                data:{},
                context:this,
                success: function(data, status, xhr) {
                    self.$emit('voucher-changed', self.cart);
                    self.validCode = false;
                }
            });
        }
    }
});

Vue.component('voucher-sidebar-component', {
    template: '#voucher-sidebar-template',
    props: {
        cart: {
            type: Object
        }
    },
    data: function() {
        return {
            siteCulture: _config.siteCulture,
            code: '',
            validCode: false,
            invalidCode: false,
            submitting: false,
            btnTextActivate: _btnTextActivate,
            btnTextRemove: _btnTextRemove
        }
    },
    methods: {
        checkCode: function(e) {
            if(e){
                e.preventDefault();
            }
            var self = this;
            self.invalidCode= false;
            self.validCode = false;
            self.submitting = true;
            jQuery.ajax({
                url:"/api/checkout/cart/promotion/", 
                type:"post",
                dataType:"json",
                data:{
                    Code:self.cart.PromotionCode,
                },
                context:this,
                success: function(data, status, xhr) {
                    self.submitting = false;
                    if (status == "success" && data.Success) {
                        self.validCode = true;
                        //self.cart.PromotionCodeValid = true;
                    } else {
                        self.invalidCode= true;
                        //self.cart.PromotionCodeValid = false;
                    };

                    setTimeout(function() {
                        self.$emit('voucher-changed', self.cart);
                    }, 1000);
                }
            });
        },
        removeCode: function(ev) {
            if(ev){
                ev.preventDefault();
            }
            var self = this;
            jQuery.ajax({
                url:"/api/checkout/cart/promotion/", 
                type:"delete",
                dataType:"json",
                data:{},
                context:this,
                success: function(data, status, xhr) {
                    self.$emit('voucher-changed', self.cart);
                    self.validCode = false;
                }
            });
        },
    }
});

/*
Vue.component('remark-component', {
    template: '#remark-template',
    props: {
        cart: {
            type: Object
        }
    },
    data: function() {
        return {
            
        }
    },
    methods: {
    
    }
});
*/

Vue.component('login-component', {
    template: '#login-template',
    props: {
        cart: {
            type: Object
        },
        defaultEmail: ''
    },
    data() {
        return {
            siteCulture: _config.siteCulture,
            email: this.defaultEmail,
            password: '',
            newAccountEmail: '',
            createNewAccount: false,
            errorExistingAccount: false,
            invalidLogin: false,
            isPending: false,
            newCustomerFormTitle: _newCustomerFormTitle,
            newCustomerFormDescription: _newCustomerFormDescription,
            btnTextLogIn: _btnTextLogin,
            btnTextProceed: _btnTextProceed
        }
    },
    methods: {
        login: function() {
            var self = this;
            self.isPending = true;
            self.invalidLogin = false;
            jQuery.ajax({
                url:"/api/identity/login/", 
                type:"post", 
                dataType:"json", 
                context:this, 
                data:{
                    username:this.email, 
                    password:this.password,
                },
                success: function(data, status, xhr) {
                    if (data.Success) {
                        self.$emit('logged-in',data.BillingAddress,data.ShippingAddress);
                        vuedlhelper.checkout_option(2, "Customer Login");
                    }
                    else {
                        self.invalidLogin = true;
                        self.isPending = false;
                    }
                },
                complete: function(xhr, status) {
                    self.isPending = false;
                }
            });
        },
        createAccount: function() {
            var self = this;
            self.isPending = true;
            self.errorExistingAccount = false;
            jQuery.ajax({
                url:"/api/identity/create/", 
                type:"post", 
                dataType:"json", 
                context:this, 
                data:{
                    emailaddress: this.newAccountEmail, 
                    useexisting: true, 
                    generatepassword: this.createNewAccount,
                    culture: "nl-NL"
                },
                success: function(data, status, xhr) {
                    if (status == "success" && data.Success) {
                        self.$emit('account-created');
                    
                    } else {
                        self.errorExistingAccount = true;
                        self.isPending = false;
                    }
                },
                complete: function(xhr, status) {
                    self.isPending = false;
                }
            });
        },
        newCustomer: function() {
            var self = this;
            self.isPending = true;
            self.$emit('new-customer');
            vuedlhelper.checkout_option(2, "New Customer");

            setTimeout(() => self.isPending = false, 3500);
        },
        test: function() {
            var self = this;
            self.isPending = true;
            alert(this.cart.ShippingMethod);

            setTimeout(() => self.isPending = false, 3500);
        }
    },
    mounted: function() {
        vuedlhelper.checkout(2);
        
    }
});

var checkout = new Vue({
    el: '#checkout',
    data: {
        ready: false,
        cart: null,
        authenticated: false,
        optIn: store.SubscribeNewsletter,
        hideOptinCheckbox: store.hideOptinCheckbox,
        new_customer: false,
        valid:false,
        culture: 'nl-NL',
        billingActive: true,
        shippingActive: false,
        paymentActive: false,
        paymentError: false,
        addressAutoFilled: false,
        loading:true,
        userName: '',
        executingOrder: false
    },
    methods: {
        getCart: function(clearSelectedBillingCountryCode) {
            var self = this;
            var url = "/api/checkout/cart?r=" + Math.random() + "&culture=" + self.culture + "&recalculate=true"; 
            if(clearSelectedBillingCountryCode) 
            {
                url = url + "&ClearSelectedBillingCountryCode=true";
            }

            jQuery.ajax({
                url: url, 
                type: "get", 
                dataType: "json", 
                context: this,
                success: function (data, status, xhr) {
                    if (status == "success") {
                        self.cart = data;
                            
                        if(!self.cart.Lines || self.cart.Lines.length == 0)
                            location.href= "/winkelwagen";

                        if(self.cart.BillingAddress.Salutation === undefined || self.cart.BillingAddress.Salutation.length ===0) {
                            self.cart.BillingAddress.Salutation = "Dhr.";
                        }

                        if(self.cart.BillingAddress.Country === undefined || self.cart.BillingAddress.Country.length ===0) {
                            self.cart.BillingAddress.Country = "";
                            self.cart.BillingAddress.CountryCode = "";
                        }

                        if(self.cart.ShippingAddress.Country === undefined || self.cart.ShippingAddress.Country.length ===0) {
                            self.cart.ShippingAddress.Country = "";
                            self.cart.ShippingAddress.CountryCode = "";
                        }

                        if(self.cart.PickupAddress.Country === undefined || self.cart.PickupAddress.Country.length ===0) {
                            if(self.cart.ShippingAddress.Country === undefined || self.cart.ShippingAddress.Country.length ===0) {
                                self.cart.PickupAddress.Country = "";
                                self.cart.PickupAddress.CountryCode = "";
                            } else {
                                self.cart.PickupAddress.Country = self.cart.ShippingAddress.Country;
                                self.cart.PickupAddress.CountryCode = self.cart.ShippingAddress.CountryCode;
                            }
                        }

                        if(this.cart.ShippingAddress.StreetName === undefined || this.cart.ShippingAddress.PostalCode === undefined){
                            this.cart.ShippingAddress.Salutation = this.cart.BillingAddress.Salutation;
                            this.cart.ShippingAddress.FirstName = this.cart.BillingAddress.FirstName;
                            this.cart.ShippingAddress.Infix = this.cart.BillingAddress.Infix;
                            this.cart.ShippingAddress.LastName = this.cart.BillingAddress.LastName;
                            this.cart.ShippingAddress.StreetName = this.cart.BillingAddress.StreetName;
                            this.cart.ShippingAddress.StreetNumber = this.cart.BillingAddress.StreetNumber;
                            this.cart.ShippingAddress.StreetNumberSuffix = this.cart.BillingAddress.StreetNumberSuffix;
                            this.cart.ShippingAddress.City = this.cart.BillingAddress.City;
                            this.cart.ShippingAddress.PostalCode = this.cart.BillingAddress.PostalCode;
                            this.cart.ShippingAddress.CountryCode = this.cart.BillingAddress.CountryCode;
                            this.cart.ShippingAddress.Country = this.cart.BillingAddress.Country;
                        }

                        if ( !self.cart.Carrier || self.cart.Carrier.length === 0 ) {
                            
                            if (this.cart.ShippingAddress.CountryCode !== "BE") {
                                self.cart.Carrier = "DHL";
                            }else{
                                self.cart.Carrier = "PostNL";
                            }
                        }

                        if(!self.cart.ShippingMethod && self.cart.ShippingMethod.length === 0 
                        || self.cart.ShippingMethod !== "pickup_store" && self.cart.ShippingMethod !== "pickup_location"
                        ) {
                            self.cart.ShippingMethod = "Delivery";
                        }
                        if(!self.cart.PaymentMethod || self.cart.PaymentMethod.length ===0) {
                            self.cart.PaymentMethod = "IDEAL";
                        }
                        
                        if(self.cart.BillingMethod === undefined || self.cart.BillingMethod.length === 0) 
                            self.cart.BillingMethod = "";

                        if(self.cart.BillingMethod && self.cart.BillingMethod.length > 0) 
                            self.cart.PaymentMethod = self.cart.BillingMethod.split(':')[0];
                    
                        if(self.cart.CustomerDateOfBirth && self.cart.CustomerDateOfBirth !== null) {
                            self.cart.CustomerDateOfBirth = moment(self.cart.CustomerDateOfBirth).toDate().toJSONLocal();
                        } else {
                            self.cart.CustomerDateOfBirth = "";
                        }

                        self.ready = true;
                        self.validate();
                    }	
                }
            });
        },
        getIdentity: function() {
            var self = this;
            jQuery.ajax({
                url: "/api/identity?r=" + Math.random(), 
                type: "get", 
                dataType: "json", 
                context: this,
                success: function (data, status, xhr) {
                    if (status == "success") {
                        self.loading = false;
                        self.authenticated = data.IsAuthenticated;
                    }   
                }
            });
        },
        getShipping: function() {
            var self = this;
            jQuery.ajax({
                url: "/api/checkout/shipping?r=" + Math.random(), 
                type: "get", 
                dataType: "json", 
                context: this,
                success: function (data, status, xhr) {
                    if (status == "success") {
                        self.cart.ShippingAddress = data.ShippingAddress;
                    }   
                }
            });
        },
        clearExtraShippingOptions: function() {
            this.cart.NoDeliveryAtNeighbours = "";
            this.cart.SignForDelivery = "";
            this.cart.EveningDelivery = "";
        },
        showLogin: function(userName) {
            this.userName = userName;
            this.new_customer = false;
            this.authenticated = false;
        },
        handlePaymentChanged: function(changedCart) {
            this.cart = changedCart;
            this.validate();
        },
        handleClearExtraShippingOptions: function() {
            this.clearExtraShippingOptions();
        },
        handleLoggedIn: function(billingAddress,shippingAddress) {
            Vue.set(this.cart,"BillingAddress", billingAddress);
            Vue.set(this.cart,"ShippingAddress", shippingAddress);
            this.authenticated = true;
            this.getCart();
            store.getIdentity();
        },
        handleAccountCreated: function() {
            this.authenticated = true;
            store.hideOptinCheckbox = false;
        },
        handleNewCustomer: function() {
            this.new_customer = true;
            store.hideOptinCheckbox = false;
        },
        handleAddressAutoFill: function() {
            this.addressAutoFilled = true;
        },
        handleBillingNext: function(optin) {
            if(this.cart.ShippingAddress.CountryCode === undefined || this.cart.ShippingAddress.CountryCode.length ===0 
            || this.cart.ShippingAddress.PostalCode === undefined || this.cart.ShippingAddress.PostalCode.length ===0) {
                this.getShipping();
            }
            this.billingActive = false;
            this.shippingActive = true;
            this.optIn = optin;

            this.validate();
        },
        handleShippingPrev: function() {
            this.shippingActive = false;
            this.billingActive = true;
        },
        handleShippingNext: function() {
            this.billingActive = false;
            this.shippingActive = false;
            this.paymentActive = true;
            this.authenticated = true;
            this.validate();
        },
        handlePaymentPrev: function() {
            this.paymentActive = false;
            this.shippingActive = true;
            this.billingActive = false;
        },
        handlePaymentNext: function (remarks, optin) {
            this.executeOrder(remarks, optin);
        },
        handleVoucherChanged: function() {;
            this.$emit('cart-changed');
            this.getCart();
        },
        handleCartChanged: function() {
            this.getCart();
        },  
        executeOrder: function(remarks,optin) {
            var self = this;
            self.executingOrder = true;
            self.isPending = true;
            if(optin){
                var mailNewsletter = {
                    "Subscribe:nieuwsbrief": true,
                }
            }
            if(!optin){
                var mailNewsletter = {
                    "Unsubscribe:nieuwsbrief": true,
                }
            }
            var orderdata = {
                IsOrder: true,
                IsForReview: true,
                Ajax: true,
                IdentityAction: "Update",
                Remarks: remarks,
                mailNewsletter
            };
            jQuery.ajax({
                url: "/_api/form/order",
                type: "post",
                dataType: "json",
                context: this,
                data: orderdata,
                success: function(data, status, xhr) {
                    if (status == "success" && data.success) {
                
                        if (data.results.url) {
                            window.location = data.results.url;
                        }
                    }
                },
                complete: function(xhr, status) {
                    if (status == "error") {
                        var p1 = xhr.responseText.indexOf("<h2 class=\"exceptionMessage\">");
                        var p2 = xhr.responseText.indexOf("</h2>");
                        alert(xhr.responseText.substring(p1 + 29, p2));
                    }
                    self.executingOrder = false;
                    self.isPending = false;
                }
            });
        },
        validate:function() {
            this.valid = this.cart
                && this.cart.BillingAddress !== undefined
                && (this.cart.BillingAddress.FirstName !== undefined && this.cart.BillingAddress.FirstName.length > 0)
                && (this.cart.BillingAddress.LastName !== undefined && this.cart.BillingAddress.LastName.length > 0)
                && (this.cart.BillingMethod !== undefined && this.cart.BillingMethod.length > 0)
                && (this.cart.ShippingMethod !== undefined && this.cart.ShippingMethod.length > 0);
        },
        getParameterByName: function(name, url) {
            if (!url) url = window.location.href;
            name = name.replace(/[\[\]]/g, '\\$&');
            var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
                results = regex.exec(url);
            if (!results) return null;
            if (!results[2]) return '';
            return decodeURIComponent(results[2].replace(/\+/g, ' '));
        }
    },
    mounted: function () {
        store.init();
        this.getIdentity();
        this.getCart(true);
        
        var status = this.getParameterByName('status')
        if(status == 'geannuleerd') {
            this.billingActive = false;
            this.shippingActive = false;
            this.paymentActive = true;
            this.paymentError = true;
        }
    }
});   